import { getReimbursment } from 'services/axios/reimbursment'

// actionTypes.js
export const GET_REIMBURSMENT_DATA = 'GET_REIMBURSMENT_DATA'
export const HANDLE_REIMBURSMENT_PAGINATION = 'HANDLE_REIMBURSMENT_PAGINATION'
export const HANDLE_APPROVED_REIMBURSMENT = 'HANDLE_APPROVED_EXPENSES'
export const HANDLE_REIMBURSMENT_EXPENSE_CATAGORIES = 'HANDLE_REIMBURSMENT_EXPENSE_CATAGORIES'

//  Action creators
export const getReimbursmentData = ({
  skip,
  limit,
  status,
  expensesFor,
  totalPrice,
  rangeDate,
  comparisonWithtotalPrice,
}) => {
  return async (dispatch) => {
    const response = await getReimbursment(
      skip,
      limit,
      status,
      expensesFor,
      totalPrice,
      rangeDate,
      comparisonWithtotalPrice,
    )
    if (response?.data?.reimbursements) {
      dispatch({
        type: GET_REIMBURSMENT_DATA,
        payload: {
          reimbursmentExpenses: response?.data?.reimbursements,
          totalCount: response?.data?.data?.totalCount,
        },
      })
    }
  }
}

export const handlePagination = (pagination) => {
  return {
    type: 'HANDLE_REIMBURSMENT_PAGINATION',
    payload: pagination,
  }
}
